module.exports = __webpack_public_path__ + "img/Seychelles.592a44a1.svg";